import i18n from "i18next"
import ReactDOM from "react-dom/client"
import { initReactI18next } from "react-i18next"

import tailwindStyles from "../styles/App.css?inline"
import indexStyles from "../styles/index.css?inline"
import commonTranslations from "./locales/en/common.json"
import schemaTranslations from "./locales/en/public_risk_schema.json"
import wizardTranslations from "./locales/en/wizard.json"
import PublicRiskPageWizard from "./PublicRiskPageWizard"

void i18n.use(initReactI18next).init({
    fallbackLng: "en",
    supportedLngs: ["en"],
    debug: false,
    react: {
        useSuspense: false,
    },
    interpolation: {
        escapeValue: false,
    },
    defaultNS: "translations",
    ns: ["translations"],
    resources: {
        en: {
            translations: {
                wizard: wizardTranslations,
                common: commonTranslations,
                ...schemaTranslations,
            },
        },
    },
})

class RiskWizard extends HTMLElement {
    connectedCallback() {
        const shadow = this.attachShadow({ mode: "open" })
        this.createAndAppendStyleElement(shadow, indexStyles)
        this.createAndAppendStyleElement(shadow, tailwindStyles)

        const container = this.createAndAppendContainer(shadow)
        ReactDOM.createRoot(container).render(<PublicRiskPageWizard />)
    }

    private createAndAppendContainer(shadow: ShadowRoot) {
        const element = document.createElement("div")
        shadow.appendChild(element)
        return element
    }

    private createAndAppendStyleElement(shadow: ShadowRoot, cssString: string) {
        const style = document.createElement("style")
        style.textContent = cssString
        shadow.appendChild(style)
        return style
    }
}

customElements.define("risk-wizard", RiskWizard)
